import Pagination from "@mui/material/Pagination";
import React, {type FC, useMemo} from "react";
import Menu, {type MenuProps} from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Button from "@mui/material/Button";
import {styled} from "@mui/material/styles";
import {useAllQueryParams} from "@/shared/lib/hooks";
import {useTranslation} from "react-i18next";
import {useSearchParams} from "react-router-dom";
import {TbListNumbers} from "react-icons/tb";

const TablePagination: FC<{
  tableData: any[];
  totalData: number;
  defaultLimit: number;
}> = ({totalData, tableData, defaultLimit}) => {
  const [_, setSearchParams] = useSearchParams();
  const allParams = useAllQueryParams();

  const pagination = useMemo(
      () => (
          <Pagination
              className="me-3"
              count={Math.ceil(+totalData / (+allParams.limit || defaultLimit))}
              variant="outlined"
              page={+allParams.page || 1}
              showFirstButton
              showLastButton
              shape="rounded"
              onChange={(_, page) =>
                  setSearchParams({...allParams, page: String(page)})
              }
          />
      ),
      [allParams]
  );

  return (
      <div className={"flex items-center !py-4"}>
        <CustomizedMenus
            currLimit={+allParams.limit || defaultLimit}
            onLimitChange={(limit) => {
              setSearchParams({...allParams, limit: String(limit), page: "1"});
            }}
        />

        {tableData?.length > 0 && pagination}
      </div>
  );
};

const StyledMenu = styled((props: MenuProps) => (
    <Menu
        elevation={0}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        {...props}
    />
))(() => ({}));

function CustomizedMenus({
                           onLimitChange,
                           currLimit,
                         }: {
  onLimitChange: (limit: number) => void;
  currLimit: number;
}) {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const {t} = useTranslation();
  return (
      <div>
        <Button className={"!px-2"} color={"primary"} variant={"outlined"} startIcon={<TbListNumbers/>}
                onClick={handleClick}>
          {currLimit} {t("PAGES_TITLE.ROWDAN")}
        </Button>
        <StyledMenu
            id="demo-customized-menu"
            MenuListProps={{
              "aria-labelledby": "demo-customized-button",
            }}
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
        >
          {[10, 20, 40, 50, 100].map((limit) => (
              <MenuItem
                  disabled={currLimit === limit}
                  onClick={() => {
                    onLimitChange(limit);
                    handleClose();
                  }}
                  disableRipple
                  key={limit}
                  sx={{
                    width: "145px",
                  }}
              >
                {limit}
              </MenuItem>
          ))}
        </StyledMenu>
      </div>
  );
}

export default TablePagination;